import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import { FiArrowRight } from "react-icons/fi";
import FlowField from "../components/forms/FlowField";
import "./styles/flow-form.css";
import { addToCart } from "../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { updateBusinessRequest } from "../redux/actions/RequestActions";
import Loader from "../components/loader/Loader";

// Validation schema
const validationSchema = Yup.object({
  businessName: Yup.string().required("Le nom de l'entreprise est requis"),
});

function HaveBusinessName() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentStep = "Entreprise";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const cart = useSelector((state) => state.cart);
  const { user } = useSelector((state) => state.authUser);
  const [submitting, setSubmitting] = useState(false);
  const { businessCreationRequest } = useSelector((state) => state.request);

  const handleSubmit = async (values) => {
    setSubmitting(true);
    await dispatch(
      addToCart({
        businessName: values.businessName,
      }),
    );
    if (cart.from === "creation") {
      await dispatch(
        updateBusinessRequest(
          user.token,
          businessCreationRequest.reference,
          {
            activitySector: cart.sectorActivity,
            deadline: cart.deadline,
            managerType: cart.managerType,
            managerName:
              cart.managerType === "myself"
                ? `${user.firstname} ${user.lastname}`
                : cart.managerName,
            ...values,
          },
          handleCallback,
        ),
      );
    } else {
      navigate("/business-address");
    }
  };

  const handleCallback = ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      navigate("/documents");
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  return (
    <div className="flow-form-page">
      <Header />
      <Loader isLoading={submitting} />
      <ProgressBar steps={steps} currentStep={currentStep} />

      <header className="flow-form-header">
        <h1 className="flow-form-title">
          Quel est le <span>nom</span> de votre{" "}
          {cart?.businessType || cart?.company?.businessType} ?
        </h1>
        <p className="flow-form-lead">
          Indiquez le nom officiel de votre entreprise.
        </p>
      </header>

      <Formik
        initialValues={{
          businessName:
            typeof cart.businessName === "string" ? cart.businessName : "",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <Form className="flow-form" noValidate>
          <FlowField
            name="businessName"
            label="Nom de l'entreprise"
            placeholder="Ex. : Kribi Digital"
            autoComplete="organization"
          />

          <div className="flow-actions">
            <button type="submit" className="flow-submit" disabled={submitting}>
              Continuer <FiArrowRight aria-hidden="true" />
            </button>
          </div>
        </Form>
      </Formik>
    </div>
  );
}

export default HaveBusinessName;
